import { createApp } from 'vue';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import App from './App.vue';
import router from './router';
import './styles.css';

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'office',
    themes: {
      office: {
        dark: false,
        colors: {
          background: '#f6f7f9',
          surface: '#ffffff',
          primary: '#2f6f73',
          secondary: '#775f43',
          accent: '#b4563c',
          error: '#b3261e',
        },
      },
    },
  },
});

createApp(App).use(router).use(vuetify).mount('#app');
